import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { organizationService } from "../../services/organization.service";
import {
	GroupLabelRequest,
	GroupLabelUpdateRequest,
} from "@/domain/groupLabel.interface";
import { SearchGroupLabelsPayload } from "@/domain/groupLabel.interface";

// CRUD hooks for organizations management
export const useGroupLabels = () => {
	return useQuery({
		queryKey: ["groupLabels"],
		queryFn: organizationService.getGroupLabels,
	});
};

export const useGroupLabelsAll = (params: SearchGroupLabelsPayload) => {
	return useQuery({
		queryKey: ["groupLabelsAll", params],
		queryFn: () => organizationService.findGroupLabelsAll(params),
	});
};

export const useCreateGroupLabel = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: (data: GroupLabelRequest) =>
			organizationService.createGroupLabel(data),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ["groupLabels"] });
		},
	});
};

export const useUpdateGroupLabel = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: (data: GroupLabelUpdateRequest) =>
			organizationService.updateGroupLabel(data),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ["groupLabels"] });
		},
	});
};

export const useDeleteGroupLabel = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: (id: string) => organizationService.deleteGroupLabel(id),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ["groupLabels"] });
		},
	});
};
